/**
 * Stripe-hosted pages (Checkout, Connect onboarding, Express dashboard) refuse
 * to render inside an iframe. When this site is embedded (e.g. the Emergent
 * preview frame) a same-tab redirect shows Chrome's grey "sad page" instead.
 *
 * Pattern: open a tab synchronously during the click (so popup blockers allow
 * it), then point it at the URL once the API responds.
 *
 *   const win = beginExternalNav();          // before any await
 *   const { url } = await api.post(...);
 *   finishExternalNav(win, url);
 */
export const isFramed = () => {
  try { return window.self !== window.top; } catch { return true; }
};

export const beginExternalNav = () => {
  if (!isFramed()) return null;
  const win = window.open("about:blank", "_blank");
  if (win) { try { win.opener = null; } catch { /* ignore */ } }
  return win;
};

export const finishExternalNav = (win, url) => {
  if (win && !win.closed) { win.location.href = url; return; }
  if (isFramed()) {
    try { window.top.location.assign(url); return; } catch { /* sandboxed frame */ }
    const w = window.open(url, "_blank", "noopener");
    if (w) return;
  }
  window.location.assign(url);
};
